<script>
import NoticeBar from 'comp/common/NoticeBar.vue'

import { getShadowColor } from '@/utils/modules/getStyles'
import { filePathFn } from '@/utils/common'

export default {
  name: 'AudioPlayer',
  components: { NoticeBar },
  props: {
    audiourl: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    },
    publisher: {
      type: String,
      default: ''
    },
    idx: {
      type: Number,
      default: 0
    },
    isplaying: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      path: this.$route.path,
      totalTime: 0,
      currentTime: 0
    }
  },
  computed: {
    audioFullPath() {
      return filePathFn(this.audiourl) // `${baseURL}/Video/${this.audiourl}`
    },
    formatTotalTime() {
      return this.formatTime(this.totalTime)
    },
    formatCurrentTime() {
      return this.formatTime(this.currentTime)
    },
    operationLogo() {
      return this.isplaying ? require('imgs/modules/playing-green.png') : require('imgs/modules/pause-green.png')
    }
  },
  watch: {
    isplaying: {
      handler: function(newVal) {
        this.$nextTick(() => {
          newVal ? this.$refs.audio.play() : this.$refs.audio.pause()
        })
      },
      immediate: true
    }
  },
  mounted() {
    // audioGroup
    // console.log('fa audio ref', this.$parent.$refs['audioGroup'][this.idx].$refs)
    this.$refs.audio.src = this.audioFullPath
    // 将range位置归0, 如果不使用这个的话, 设置了value之后没有用
    setTimeout(() => {
      this.$refs.range.value = 0
    }, 1)
  },
  methods: {
    getShadowColor,
    onAudioClick() {
      const audio = this.$refs.audio
      const audioList = this.$parent.$refs['audioGroup']
      this.isplaying ? audio.pause() : audio.play()
      // this.isPlay = !this.isPlay
      this.$emit('handleAudioClick', this.idx)
      audioList.forEach(item => {
        if (item.$refs.audio.className !== this.$refs.audio.className) item.$refs.audio.pause()
      })
    },
    loadingFinish() {
      const totalTime = this.$refs.audio.duration
      this.totalTime = totalTime
    },
    // range--拖动进度条得到的回调
    onChange() {
      let value = this.$refs.range.value
      const persentage = ((value / 360) * 100).toFixed(1) + '%'
      this.$refs.range.style.backgroundSize = `${persentage} 100%`
      // 控制音频播放
      const timeToGo = (value / 360) * this.totalTime
      const audio = this.$refs.audio
      audio.currentTime = timeToGo
    },
    // audio--进度变化的时候的回调--改变文字
    update() {
      const audio = this.$refs.audio
      if (!audio) return
      const currentTime = audio.currentTime || 0 // 当前播放时间
      this.currentTime = currentTime
      // 改变进度条的值
      const range = this.$refs.range
      range.value = ((this.currentTime / this.totalTime) * 360).toFixed(1)
      // 进度条的值改变的时候，颜色也跟着变化
      const persentage = ((this.currentTime / this.totalTime) * 100).toFixed(1) + '%'
      this.$refs.range.style.backgroundSize = `${persentage} 100%`
    },
    formatTime(val) {
      const value = Number(val)
      let second = 0
      let minute = 0
      minute = parseInt(value / 60)
      second = parseInt(value % 60)
      minute = minute < 10 ? `0${minute}` : minute
      second = second < 10 ? `0${second}` : second
      return `${minute}:${second}`
    }
  }
}
</script>

<template>
  <div class="audio-player-container">
    <div class="audio-container" :style="{boxShadow: `0 3px 10px 0 ${getShadowColor}`}">
      <el-image
        class="audio-logo"
        :class="{'audio-logo-animation': isplaying}"
        :src="require('imgs/modules/audio-logo.png')"
        alt="audio-logo"
      />

      <div class="audio-msg">
        <NoticeBar v-if="title && title.length > 9" :text="title" />
        <p v-else class="audio-title h-line-1">{{ title || "未知" }}</p>
        <p v-if="publisher" class="h-line-1 audio-source">来源 -- {{ publisher || '暂无' }}</p>
        <p class="audio-time">时长: {{ formatTotalTime }}</p><!-- {{ formatCurrentTime }} /  -->
      </div>

      <div class="progress-box">
        <div class="progress"><!-- v-show="isplaying" -->
          <input ref="range" type="range" min="0" max="360" value="0" @input="onChange" @change="onChange">
        </div>
        <div class="pointer operation-box" :class="{'pause-box': !isplaying}" @click.stop="onAudioClick">
          <el-image :src="operationLogo" class="operation-logo" />
        </div>
      </div>
    </div>
    <audio
      ref="audio"
      style="display: none"
      :class="`audio-comp-${idx}`"
      :src="audioFullPath"
      controls
      @timeupdate="update"
      @canplay="loadingFinish"
    />
  </div>
</template>

<style lang="scss" scoped>
.audio-container {
  width: 220px;
  height: 290px;
  padding: 20px 25px;
  box-sizing: border-box;
  background: url('~imgs/modules/module-61-bg.png') no-repeat right top;
  background-size: 78px 135px;
  background-color: #fff;
  box-shadow: 0 3px 10px 0 rgba(7,60,0,0.1);
  border-radius: 5px;
  .audio-logo {
    width: 63px;
    height: 63px;
  }
  .audio-logo-animation {
    animation: audio-logo-rotate 6s linear infinite;
  }
}
.audio-msg {
  width: 170px;
  .audio-title {
    font-size: 17px;
    font-weight: 800;
    color: #040000;
    margin-top: 20px;
  }
  .audio-source {
    font-size: 15px;
    color: var(--grey-text-color);
    margin-top: 10px;
  }
  .audio-time {
    font-size: 15px;
    color: var(--grey-text-color);
    margin-top: 20px;
  }
}
.progress-box {
  width: 170px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;
  .operation-box {
    width: 45px;
    height: 45px;
    border: 1px solid #5F977D;
    border-radius: 50%;
    display: grid;
    place-items: center;
  }
  .pause-box {
    padding-left: 3px;
  }
  .operation-logo {
    width: 17px;
    height: 21px;
  }
}

// 控件
input[type='range'] {
  outline: none;
  -webkit-appearance: none; /*清除系统默认样式*/
  width: 93px !important;
  background: -webkit-linear-gradient(#5F977D, #5F977D) no-repeat, #E8E8E8; /*背景颜色，俩个颜色分别对应上下*/
  background-size: 0% 100%; /*设置左右宽度比例，这里可以设置为拖动条属性*/
  height: 3px;
  border-radius: 2px;
}
/*拖动块的样式*/
input[type='range']::-webkit-slider-thumb {
  -webkit-appearance: none; /*清除系统默认样式*/
  height: 8px;
  width: 8px;
  border-radius: 50%;
  background: #5F977D; /*拖动块背景*/
}

@keyframes audio-logo-rotate {
  0% {transform: rotate(0);}
  100% {transform: rotate(360deg);}
}
</style>
